import getSplitedPath from '@/services/functions/getSplitedPath'
function getNestedValue (fieldName, dataItem) {
  if (!fieldName) {
    return dataItem
  }
  const path = getSplitedPath(fieldName)
  let data = dataItem
  path.forEach((p) => {
    data = data ? data[p] : undefined
  })
  
  return data
}

export default getNestedValue


// splitEscapedPath2 = function (fieldName) {
//   var result = fieldName.replace(/([^.])\[(\d+)\]/g, '$1.$2')
//   result = result.replace(/\[(\d+)\]/, '$1')
//   result = result.match(/(?:[^\\.]|\\.|\\\\)+/g)
//   result = result.flatMap(part => {
//     var partresult = part.replace(/\\\\\./g, '\u0000') // placeholder para \\.
//     partresult = partresult.replace(/\\\./g, '\u0001') // placeholder para \.
//     partresult = partresult.split('.') // split por puntos normales
//     partresult = partresult.map(p => {
//       var presult = p.replace('\u0001', '.')
//       presult = presult.replace('\u0000', '\\')
//       return presult
//     }
//     )
//     return partresult
//   }
//   )
//   return result
// }
